export const dotenv = {
  API_BASE_URL: 'https://api-stg.mykinships.com',
  NOTIFICATION_BASE_URL: 'https://api-stg-notification.mykinships.com',
  FRONTEND_BASE_URL: 'https://app-stg.mykinships.com',
  MEDIA_BASE_URL: 'https://api-stg-media.mykinships.com',
  NODE_TLS_REJECT_UNAUTHORIZED: '0',
  BUCKET: 'mykinship-stg-assets',
  ENV: 'stg'
};
